module.exports = __webpack_public_path__ + "static/media/newtonBg.f39db81d.png";